import api from './index';

const searchShipment = (status, date, timezone, bol, phone, name, destination) => api.get('/shipment/search', {
  params: {
    ...Object.fromEntries(Object.entries({
      status,
      date,
      timezone,
      // 'shipment-id': shipmentId,
      bol,
      phone,
      name,
      destination,
    }).filter((kv) => !!kv[1])),
  },
});

const searchManifest = (date, timezone, bol, departure, destination) => api.get('/manifest/search', {
  params: {
    ...Object.fromEntries(Object.entries({
      date,
      timezone,
      bol,
      departure,
      destination,
    }).filter((kv) => !!kv[1])),
  },
});

const delayedShipment = () => api.get('/delayedShipment');

const unpaidShipment = () => api.get('/unpaidShipment');

// eslint-disable-next-line import/prefer-default-export
export {
  searchShipment, delayedShipment, unpaidShipment, searchManifest,
};
